exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-disabled[data-v-28d3c318] {\n  opacity: 0.2 !important;\n  cursor: not-allowed;\n  pointer-events: all !important;\n}\n", ""]);

// exports
